import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { EmitterService } from '../../services/emitter.service';

@Component({
  selector: 'app-growler',
  templateUrl: './growler.component.html',
  styleUrls: ['./growler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GrowlerComponent implements OnInit, OnDestroy {
  private emitterService = inject(EmitterService);

  @Input() public type: 'success' | 'warning' | 'error' = 'success';
  @Input() public position: 'relative' | 'fixed' = 'relative';

  public isVisible = true;

  public ngOnInit(): void {
    if (this.position === 'fixed') {
      this.emitterService.setFixedGrowlerDisplayed(true);
    }
  }

  public ngOnDestroy(): void {
    if (this.position === 'fixed') {
      this.emitterService.setFixedGrowlerDisplayed(false);
    }
  }

  public onUndo(): void {
    this.isVisible = false;
    if (this.position === 'fixed') {
      this.emitterService.setFixedGrowlerDisplayed(false);
    }
  }
}
